import React, { useState } from "react";
import { Modal, Button, Input, Dropdown } from "semantic-ui-react";
import { producaov2 as api, local } from "../../../../services/apis";
import { InputContainer } from "./styled";
import InputMask from "react-input-mask";
import swal from "sweetalert";
import CursosSelector from "../../CursosSelector";
import { getUserNode } from "../../../../services/auth_node";
import { PLAN_PAYMENT_METHODS } from "../../../../constants";
import { financialUsers, TIUsers } from "../../../../utils/Utils";

const getOneYearFromNow = () => {
  const date = new Date();
  date.setFullYear(date.getFullYear() + 1);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export default function ModalCreatePlan({ open, handleClose }) {
  const [name, setName] = useState("");
  const [price, setPrice] = useState("");
  const [cycles, setCycles] = useState();
  const [courseId, setCourseId] = useState();
  const [paymentMethods, setPaymentMethods] = useState([
    PLAN_PAYMENT_METHODS[0].value,
  ]);
  const [loading, setLoading] = useState(false);
  const [isCustomCourseValidity, setIsCustomCourseValidity] = useState(false);
  const [isLifetimeAccess, setIsLifetimeAccess] = useState(false);
  const [courseValidityDate, setCourseValidityDate] = useState(getOneYearFromNow());
  const user = getUserNode().id;
  const email = getUserNode().email;

  const calculateDaysDifference = (targetDate) => {
    if (!targetDate) return null;
    const today = new Date();
    today.setHours(12, 0, 0, 0);
    
    // Parseia a data no formato YYYY-MM-DD sem problemas de timezone
    const [year, month, day] = targetDate.split('-').map(Number);
    const target = new Date(year, month - 1, day, 12, 0, 0, 0);
    
    const diffTime = Math.abs(target - today);
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24)) + 1; // +1 para contar o dia de hoje
    return diffDays;
  };

  const handleSubmit = async () => {
    if (name === "" || price === "" || cycles === "" || !courseId) {
      swal("Preencha todos os campos!", "", "error");
      return;
    }

    // Validação da data de validade do curso
    if (isCustomCourseValidity && !isLifetimeAccess) {
      if (!courseValidityDate) {
        swal("Data de validade do curso inválida", "Por favor, informe uma data de validade para o curso.", "error");
        return;
      }
      
      const [year, month, day] = courseValidityDate.split('-').map(Number);
      const selectedDate = new Date(year, month - 1, day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (selectedDate <= today) {
        swal("Data de validade do curso inválida", "A data de validade do curso deve ser maior que a data de hoje.", "error");
        return;
      }
    }

    setLoading(true);

    const payload = {
      name,
      price: Number(price.replace(",", ".")).toFixed(2).replace(".", ","),
      cycles,
      courseId,
      interval: "month",
      paymentMethods: paymentMethods.join(","),
    };

    if (isCustomCourseValidity) {
      if (isLifetimeAccess) {
        payload.dias_validade_curso = 180;
      } else if (courseValidityDate) {
        payload.dias_validade_curso = calculateDaysDifference(
          courseValidityDate,
        );
      }
    }

    await api
      .post("/admin/planos/assinatura", payload)
      .then((res) => {
        api.post("/admin/log/register", {
          actions: `Criou link recorrente: : ${name}`,
        });
        swal("Plano criado com sucesso!", "", "success");
        closeModal();
      })
      .catch((err) => {
        console.log(err);
        const data = err?.response?.data;
        // GlobalError da API vem em `message`; erro de validação da Pagarme vem em `response.data`
        const detail =
          data?.message ||
          (data?.response?.data && JSON.stringify(data.response.data)) ||
          err?.message ||
          "Erro desconhecido";
        swal("Não foi possível criar o plano", detail, "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const closeModal = () => {
    setName("");
    setPrice("");
    setCycles(null);
    setPaymentMethods([PLAN_PAYMENT_METHODS[0].value]);
    setIsCustomCourseValidity(false);
    setIsLifetimeAccess(false);
    setCourseValidityDate(getOneYearFromNow());
    handleClose(false);
  };

  const interval = [
    {
      key: 0,
      text: "Diário",
      value: "day",
    },
    {
      key: 1,
      text: "Semanal",
      value: "week",
    },
    {
      key: 2,
      text: "Mensal",
      value: "month",
    },
    {
      key: 3,
      text: "Anual",
      value: "year",
    },
  ];

  const canChoosePaymentMethods = [...TIUsers, ...financialUsers].includes(
    email,
  );

  const maxNameCount = 64;

  /**
   * Adição para não permitir criar os recorrente com os livros
   */
  const bookCourseIDs = [6625, 6626, 6627];

  return (
    <Modal size={"small"} open={open} onClose={() => closeModal()}>
      <Modal.Header>Cria novo plano de assinatura</Modal.Header>
      <Modal.Content>
        <Modal.Description></Modal.Description>

        <InputContainer>
          <label>Name</label>
          <Input
            placeholder="ALL IN"
            value={name}
            onChange={(e) => setName(e.target.value)}
          >
            <input maxLength={maxNameCount} />
          </Input>
          <span>
            {name?.length || 0} / {maxNameCount} caracteres
          </span>
        </InputContainer>
        <InputContainer>
          <label>Valor da parcela</label>
          <Input
            placeholder="300"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </InputContainer>
        <InputContainer>
          <label>Quantas parcelas</label>
          <Input
            type="number"
            placeholder="12"
            value={cycles}
            onChange={(e) => setCycles(e.target.value)}
          />
          {/*<label>Intervalo de cobrança</label>
           <Dropdown
            placeholder="Selecionar"
            fluid
            selection
            options={interval}
            value={paymentInterval}
            onChange={(e, data) => setPaymentInterval(data.value)}
          /> */}
        </InputContainer>
        {canChoosePaymentMethods && (
          <InputContainer>
            <label>Formas de Pagamento</label>
            <Dropdown
              fluid
              selection
              multiple
              value={paymentMethods}
              onChange={(e, { value }) => setPaymentMethods(value)}
              options={PLAN_PAYMENT_METHODS}
            />
          </InputContainer>
        )}
        <CursosSelector
          handleChange={setCourseId}
          excludeCourseIDs={bookCourseIDs}
        />

        <InputContainer>
          <h3 style={{ display: "flex", gap: "0.5rem" }}>
            Validade de acesso ao curso diferente?
            <input
              type="checkbox"
              id="isCustomCourseValidity"
              checked={isCustomCourseValidity}
              onChange={(e) => {
                setIsCustomCourseValidity(e.target.checked);
                if (!e.target.checked) {
                  setCourseValidityDate("");
                  setIsLifetimeAccess(false);
                }
              }}
            />
          </h3>

          {isCustomCourseValidity && (
            <>
              <InputContainer>
                <label style={{ display: "flex", gap: "0.5rem" }}>
                  Acesso Vitalício (Sem expiração)
                  <input
                    type="checkbox"
                    id="isLifetimeAccess"
                    checked={isLifetimeAccess}
                    onChange={(e) => {
                      setIsLifetimeAccess(e.target.checked);
                      if (e.target.checked) {
                        setCourseValidityDate("");
                      }
                    }}
                  />
                </label>

                {!isLifetimeAccess && (
                  <>
                    <label>Data de Validade do Curso</label>
                    <Input
                      type="date"
                      value={courseValidityDate}
                      onChange={(e) => setCourseValidityDate(e.target.value)}
                    />
                  </>
                )}
              </InputContainer>
            </>
          )}
        </InputContainer>
      </Modal.Content>
      <Modal.Actions>
        <Button
          loading={loading}
          type="button"
          color="orange"
          onClick={() => handleSubmit()}
        >
          Cadastrar
        </Button>
        <Button onClick={() => closeModal()}>Cancelar</Button>
      </Modal.Actions>
    </Modal>
  );
}
